import React from "react";
import { slider1Images } from "./Data";

const SliderSection = props => {
  return (
    <div
      className="fullwidth slider-section text-center container"
      id="SliderSection"
    >
      <div className="container-fluid">
        <div id="slider1" className="owl-carousel owl-theme">
          {slider1Images.map(img => {
            const { id, imgUrl, imgAlt } = img;
            return (
              <div className="item" key={id}>
                <img alt={imgAlt} src={imgUrl} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SliderSection;



// WEBPACK FOOTER //
// ./src/components/Home/Slider1-Section.js